import { PoaItem } from '@builddocs/data-management'
import { Notification } from '@builddocs/mui'
import { Flex, Radio, RadioChangeEvent, Typography } from 'antd'

import { ProxyCard } from './selected-card/selected-card'

type ProxySelectorProps = {
  proxy: PoaItem[] | undefined
  onSelect: (selectedProxyId: string | null) => void
  selectedProxyId: string | null
  selectedProxy: PoaItem | undefined
  isValid: boolean | undefined
  errorMessage: string | undefined
  isProxyRequired?: boolean
}

export const ProxySelector = ({
  proxy,
  onSelect,
  selectedProxyId,
  selectedProxy,
  isValid,
  errorMessage,
  isProxyRequired = false,
}: ProxySelectorProps) => {
  const handleChange = (e: RadioChangeEvent) => {
    onSelect(e.target.value)
  }

  // Опции для выбора: если МЧД требуется, убираем "Без доверенности"
  const radioOptions = [
    ...(!isProxyRequired ? [{ label: 'Без доверенности', value: null }] : []),
    ...(proxy || []).map(item => ({
      label: item.poaName,
      value: item.poaIdInternal,
    })),
  ]

  return (
    <div style={{ marginTop: 16 }}>
      <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
        <Typography.Title
          level={5}
          style={{ marginBottom: 0, textAlign: 'center' }}
        >
          Выберите доверенность{isProxyRequired && ' *'}
        </Typography.Title>
      </Flex>
      {isProxyRequired && !selectedProxyId && (
        <Notification
          message="Требуется выбор доверенности"
          sx={{
            backgroundColor: '#FFF4E5',
            borderRadius: '10px',
            padding: '12px 16px',
            marginBottom: '16px',
          }}
        >
          <Typography.Text
            style={{
              fontFamily: 'Roboto',
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '20px',
              color: '#333333',
            }}
          >
            Для данного сертификата обязательно требуется выбор машиночитаемой
            доверенности (МЧД).
          </Typography.Text>
        </Notification>
      )}
      <Radio.Group
        options={radioOptions}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          marginBottom: 16,
        }}
        value={selectedProxyId}
        onChange={handleChange}
      />
      {!proxy?.length && (
        <Notification
          message={
            <div style={{ fontSize: '16px' }}>Доверенности не добавлены</div>
          }
          sx={{
            backgroundColor: '#EAEEF8',
            borderRadius: '10px',
            padding: '20px 24px',
          }}
        >
          <Typography.Text
            style={{
              fontFamily: 'Roboto',
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '20px',
              letterSpacing: '0',
              color: '#333333',
            }}
          >
            <div style={{ height: '12px' }} />
            Можете добавить доверенность в профиле пользователя.
            <div style={{ height: '12px' }} />
            Выпустить доверенность можно&nbsp;
            <Typography.Link
              href="https://m4d.nalog.gov.ru/EMCHD"
              target="_blank"
            >
              тут
            </Typography.Link>
            &nbsp;и&nbsp;
            <Typography.Link
              href="https://partners.gosuslugi.ru/catalog/eservice-form"
              target="_blank"
            >
              тут
            </Typography.Link>
          </Typography.Text>
        </Notification>
      )}
      {isValid === false && (
        <Notification
          message={errorMessage}
          sx={{
            background: '#f5f7fa',
            borderRadius: '4px',
            padding: '12px',
          }}
        />
      )}
      {selectedProxyId && selectedProxy && <ProxyCard proxy={selectedProxy} />}
    </div>
  )
}
